"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createContext = void 0;
var react_1 = __importDefault(require("react"));
var immer_1 = require("immer");
function createContext(initialState, createActions) {
    var context = react_1.default.createContext({
        state: initialState,
        setState: function (modifier) { },
    });
    var useContext = function () {
        var ctx = react_1.default.useContext(context);
        return ctx;
    };
    function useSelectState(select) {
        var state = useContext().state;
        return select(state);
    }
    var useActions = function () {
        var setState = useContext().setState;
        var actions = createActions(setState);
        return actions;
    };
    var Provider = function (props) {
        var _a = react_1.default.useState(initialState), state = _a[0], setState = _a[1];
        var setImmerState = react_1.default.useCallback(function (modifier) {
            setState(function (state) { return immer_1.produce(state, modifier); });
        }, []);
        return (react_1.default.createElement(context.Provider, { value: { state: state, setState: setImmerState } }, props.children));
    };
    return {
        useContext: useContext,
        useSelectState: useSelectState,
        useActions: useActions,
        Provider: Provider,
    };
}
exports.createContext = createContext;
